// Open mega-menu panels on hover (desktop). Listeners are attached ONCE per
// <details> using mouseenter/mouseleave (which do not bubble), so moving the
// pointer between the summary and the panel no longer re-binds handlers.
//
// The panel (.mega-menu__content) is absolutely positioned at top:99% while
// .mega-menu is position:static, leaving a gap of empty header space between
// the menu item and the panel. Crossing that gap fires mouseleave on the
// <details>, so we delay the close by a short grace period; re-entering the
// <details> (which includes the panel, a descendant) cancels it. This lets the
// pointer travel down to the panel without it closing prematurely.
const inlineMenu = document.querySelector('.header__inline-menu');

if (inlineMenu) {
  const items = inlineMenu.querySelectorAll(
    "details[id^='Details-HeaderMenu-'].mega-menu"
  );
  const CLOSE_DELAY = 250; // ms grace period to cross the gap toward the panel

  items.forEach((item) => {
    const summary = item.querySelector('summary');
    let closeTimer = null;

    const open = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      item.setAttribute('open', 'true');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = () => {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        item.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        closeTimer = null;
      }, CLOSE_DELAY);
    };

    // mouseenter/mouseleave fire once for the whole <details> subtree.
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', scheduleClose);
  });
}
